import React from "react";
import ActiveTabPicker from "../../components/ActiveTabPicker";
import { EXACT_PAY_MAX_SLIPPAGE_TABS } from "../../constants/slippage";
import { ExactPaySlippageTypes } from "../../types";

interface MaxSlippageFieldProps {
  activeTabId: ExactPaySlippageTypes;
  onTabClick: (tabId: ExactPaySlippageTypes) => void;
  tabsInfo?: any[];
}

const MaxSlippageField = ({
  activeTabId,
  onTabClick,
  tabsInfo = EXACT_PAY_MAX_SLIPPAGE_TABS,
}: MaxSlippageFieldProps) => (
  <ActiveTabPicker
    tabsInfo={tabsInfo}
    activeTabId={activeTabId}
    onClickTab={(tabId) => onTabClick(tabId as ExactPaySlippageTypes)}
  />
);

export default MaxSlippageField;
